/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Restore_No_Transaction_Content_CnaInputs */

const en_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const ar_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const de_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const es_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const fr_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const it_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const ja_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const ko_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const pt_br_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const ru_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const th_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const tr_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find a record of your Plus membership purchase.`)
};

const zh_cn_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查无 Plus 会员购买纪录`)
};

const zh_tw_dialog_restore_no_transaction_content_cna = /** @type {(inputs: Dialog_Restore_No_Transaction_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查无 Plus 会员购买纪录`)
};

/**
* | output |
* | --- |
* | "We couldn't find a record of your Plus membership purchase." |
*
* @param {Dialog_Restore_No_Transaction_Content_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_restore_no_transaction_content_cna = /** @type {((inputs?: Dialog_Restore_No_Transaction_Content_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Restore_No_Transaction_Content_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "ar") return ar_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "de") return de_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "es") return es_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "fr") return fr_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "it") return it_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "ja") return ja_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "ko") return ko_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "pt_br") return pt_br_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "ru") return ru_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "th") return th_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "tr") return tr_dialog_restore_no_transaction_content_cna(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_restore_no_transaction_content_cna(inputs)
	return zh_tw_dialog_restore_no_transaction_content_cna(inputs)
});